<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-breadcrumbs-docs-preview></ui-breadcrumbs-docs-preview></p>
<h1 id="description">Description</h1>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-breadcrumbs</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-breadcrumb</span> *<span class="hljs-attr">ngFor</span>=<span class="hljs-string">"let crumb of manyCrumbs"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">a</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"https://bannerflow.com"</span>&gt;</span>{{ '{' }}{{ '{' }}crumb{{ '}' }}{{ '}' }}<span class="hljs-tag">&lt;/<span class="hljs-name">a</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">ui-breadcrumb</span>&gt;</span>
    <span class="hljs-comment">&lt;!-- if you want the last item not to have link --&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-breadcrumb</span>&gt;</span>Last Item<span class="hljs-tag">&lt;/<span class="hljs-name">ui-breadcrumb</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-breadcrumbs</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
